import React from 'react';
import { useAuth } from '../../context/AuthContext';

// Reusable gradient header strip shown at the top of an Education-tenant module
// page so every module has a consistent identity bar:
//   - School name (from tenant)
//   - Module label
//   - Optional context chips (class, section, date, custom badges)
//
// Matches the style used by Staff Timetable so all modules feel of-a-piece.
//
// Usage:
//   <ModuleHeaderStrip
//      icon="bi-calendar-check"
//      label="Attendance"
//      chips={[
//        { label: 'Class', value: 'Class 10' },
//        { label: 'Section', value: 'A' },
//        { label: 'Date', value: '2026-04-25' },
//      ]}
//      right={<button>...</button>}
//   />
export default function ModuleHeaderStrip({
  icon = 'bi-grid',
  label = '',
  subtitle = '',
  chips = [],
  right = null,
  variant = 'default',  // 'default' | 'success' | 'warning' | 'info'
}) {
  const { tenant } = useAuth();

  const gradients = {
    default: 'linear-gradient(135deg, #ede9fe, #fce7f3)',
    success: 'linear-gradient(135deg, #dcfce7, #d1fae5)',
    warning: 'linear-gradient(135deg, #fef3c7, #fde68a)',
    info:    'linear-gradient(135deg, #e0f2fe, #ddd6fe)',
  };

  return (
    <div className="card mb-3" style={{ background: gradients[variant] || gradients.default, border: 'none' }}>
      <div className="card-body py-3">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
          <div>
            <h5 className="mb-0 fw-bold" style={{ color: '#1e293b' }}>
              <i className={`bi ${icon} me-2 text-primary`}/>
              {tenant?.name || 'School'}
              {label && <> · <span className="text-muted">{label}</span></>}
            </h5>
            {(chips.length > 0 || subtitle) && (
              <div className="small text-muted mt-1 d-flex flex-wrap align-items-center gap-2">
                {chips.filter(c => c.value).map((c, i) => (
                  <span key={i}>
                    {i > 0 && <span className="mx-1 opacity-50">·</span>}
                    <strong>{c.label}:</strong> {c.value}
                  </span>
                ))}
                {subtitle && (
                  <>
                    {chips.length > 0 && <span className="mx-1 opacity-50">·</span>}
                    {subtitle}
                  </>
                )}
              </div>
            )}
          </div>
          {right && <div>{right}</div>}
        </div>
      </div>
    </div>
  );
}
